import { render, staticRenderFns } from "./app.vue?vue&type=template&id=1b97e634&scoped=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"
import style0 from "./app.vue?vue&type=style&index=0&id=1b97e634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97e634",
  null
  
)

export default component.exports